import React from 'react';
import { FolderOpen } from 'lucide-react';
import EntityDocuments from '../../../documents/components/EntityDocuments';
import DocumentUploader from '../../../documents/components/DocumentUploader';
import { deleteDocument } from '../../../documents/api/documentsAPI';
import { useNotification } from '../../../../context/NotificationContext';
import { Card, CardHeader, CardTitle, CardContent } from '../../../../components/ui/Card';

export default function TransactionDocuments({ transaction, onRefresh }) {
  const { showToast } = useNotification();

  const handleDocumentDelete = async (documentId) => {
    try {
      await deleteDocument(documentId);
      showToast("Document supprimé avec succès", "success");
      if (onRefresh) onRefresh();
    } catch (error) {
      console.error(error);
      showToast("Erreur lors de la suppression du document", "error");
    }
  };

  const handleUploadComplete = () => {
    if (onRefresh) onRefresh();
  };

  return (
    <div className="space-y-6">
      <Card className="shadow-hp-sm">
        <CardHeader className="flex flex-row items-center gap-3 border-b border-[var(--hp-color-border-muted)] p-6">
          <FolderOpen className="h-5 w-5 text-primary" />
          <div>
            <CardTitle className="text-lg font-bold text-primary">
              Pièces & Documents de l'opération
            </CardTitle>
            <p className="mt-0.5 text-sm text-subtle">
              Consultez et téléversez les contrats, justificatifs et analyses d'investissements.
            </p>
          </div>
        </CardHeader>
        <CardContent className="p-6">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div className="flex h-full flex-col">
              <EntityDocuments
                documents={transaction.documents || []}
                onDelete={handleDocumentDelete}
              />
            </div>

            <div className="flex h-full flex-col">
              <DocumentUploader
                transactionId={transaction.id}
                onUploadComplete={handleUploadComplete}
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
